module.exports = __webpack_public_path__ + "static/assets/2b4fc8139d14625129d9fc6b9924d2c8.png";